import React, { Component } from "react";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import BlogTile from "../component/blogList/blogTile";
import themeLarge from "../component/ThemeLarge";
import Footer from "../component/Footer";
import LoadingLottie from "../component/Loading";

class BlogsPage extends Component {
  constructor(props) {
    super(props);
    const funnyLoadingTexts = [
      "Sharpening pencils and brewing coffee...",
      "Convincing the blogs to come out...",
      "Summoning the ancient blog spirits...",
      "Loading... because good blogs take time!",
      "Building blogs brick by brick...",
      "Sweeping the blog floor for you...",
      "Counting sheep... Oh wait, blogs!",
      "Pulling blogs out of a magic hat...",
      "Detective at work: Finding blogs...",
      "Warming up the engines for blog liftoff...",
    ];
    this.state = {
      isMobileView: window.innerWidth <= 1100,
      blogs: [], // Store fetched blogs
      featuredBlog: null,
      loading: true,
      loadingText:
        funnyLoadingTexts[Math.floor(Math.random() * funnyLoadingTexts.length)],
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateWindowSize);
    this.fetchPublishedBlogs();
  }

  // Remove event listener when the component unmounts to avoid memory leaks
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  // Fetch published blogs from Firestore
  fetchPublishedBlogs = async () => {
    const db = getFirestore();

    try {
      // 🔁 Get all published blogs
      const q = query(
        collection(db, "blogs"),
        where("status", "==", "published")
      );
      const querySnapshot = await getDocs(q);
      const allBlogs = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // ⏳ Sort regular blogs by createdAt descending (latest first)
      allBlogs.sort((a, b) => b.createdAt.toMillis() - a.createdAt.toMillis());

      this.setState({
        blogs: allBlogs,
        loading: false,
      });
    } catch (error) {
      this.setState({ loading: false }); // even if error, stop loading
    }
  };

  handleCardClick = (slug) => {
    const { navigate } = this.props;
    navigate(`/blogs/${slug}`);
  };

  render() {
    const { blogs, loading, loadingText, isMobileView } = this.state;

    if (loading) {
      return (
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{
            height: "100vh",
            background: themeLarge.colors.bg,
            color: themeLarge.colors.text,
          }}
        >
          <LoadingLottie />
          <p
            style={{
              fontFamily: "Kumbh Sans",
              fontSize: themeLarge.fontSize.h3,
            }}
          >
            {loadingText}
          </p>
        </div>
      );
    }

    return (
      <div>
        <div
          className="container-fluid pt-2"
          style={{
            marginTop: isMobileView ? "0px" : "75px",
            minHeight: "100vh",
            background: themeLarge.colors.bg,
          }}
        >
          {/* <FeaturedBlogView
            featuredBlog={featuredBlog}
            onClick={() => this.handleCardClick(featuredBlog?.slug)}
          /> */}

          <div className="container">
            <p
              className="d-flex justify-content-center align-items-center"
              style={{
                color: themeLarge.colors.primary,
                fontSize: isMobileView
                  ? themeLarge.fontSize.h1
                  : themeLarge.fontSize.display,
                font: "Kumbh Sans",
                fontWeight: "600",
              }}
            >
              My Blogs
            </p>

            <div className="row">
              {blogs.length === 0 ? (
                <p
                  className="text-center text-muted"
                  style={{ fontStyle: "italic" }}
                >
                  No time to write blogs yet, but something awesome is on its
                  way!
                </p>
              ) : (
                blogs.map((blog) => (
                  <div
                    key={blog.id}
                    // className={isMobileView ? "col-12 mb-2" : "col-md-6 mb-4"}
                    className={isMobileView ? "col-12 mb-2" : "col-12 mb-4"}
                    onClick={() => this.handleCardClick(blog.slug)}
                    style={{
                      cursor: "pointer",
                      padding: isMobileView ? "10px 16px" : undefined,
                    }}
                  >
                    <BlogTile blog={blog} />
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

// Higher-order component to use navigation
function withNavigation(Component) {
  return function Wrapper(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

export default withNavigation(BlogsPage);
